module.exports = require('./helpers/bundle-url').getBundleURL('6ZipN') + "logo.c51670a8.svg";